export default {
  default: [{
    url: '/how-it-works',
    title: 'Product',
    subnav: {
      layout: '',
      items: [
        {
          title: 'How it works',
          url: '/how-it-works',
          description: 'Grow your business with better bespoke visuals that are easier than ever to order.',
          icon: '/subnav/hiw.svg',
        },
        {
          title: 'Features',
          url: '/features',
          description:
            'Remove all the friction in content production, speeding up your workflow and driving more sales.',
          icon: '/subnav/features.svg',
        },
        {
          title: 'Integrations',
          url: '/integrations',
          description:
            'Connect your sales, cloud, and content management tools. Get content delivered exactly where you need it.',
          icon: '/subnav/integrations.svg',
        },
        {
          className: 'bg-beige',
          title: 'Pricing',
          url: '/pricing',
          description:
            'Our pricing is fair, flat, and transparent. Put all of your orders on a single invoice, paid monthly.',
          icon: '/subnav/pricing.svg',
        },
      ],
    },
  },
  {
    url: '/enterprise',
    title: 'Enterprise',
  },
  {
    url: '#',
    title: 'Company',
    subnav: {
      layout: '',
      items: [
        {
          title: 'About us',
          url: '/about-us',
          description: 'We created the world’s first Visual Production Platform. This is our story.',
          icon: '/subnav/about-new.png',
        },
        {
          title: 'Careers',
          url: '/careers',
          description: 'We love what we do, and we love who we get to do it with. Join the team.',
          icon: '/subnav/careers-new.png',
        },
        {
          title: 'Contact',
          url: '/contact',
          description: 'Say hello to our sales team or have a chat with support. We’re here for you.',
          icon: '/subnav/contact-new.png',
        },
        {
          type: 'block-row',
          items: [
            {
              title: 'Our Manifesto',
              url: '/manifesto',
              description: 'We are setting entirely new standards for content production.',
            },
            {
              title: 'Impact',
              url: '/social-impact',
              description: 'Our global production platform carries global responsibility.',
            },
            {
              title: 'Press',
              url: '/press',
              description: 'Find all the high-quality assets you need or talk with our PR team.',
            },
          ],
        },
      ],
    },
  },
  {
    url: '/resources',
    title: 'Resources',
    subnav: {
      layout: 'resources',
      items: [
        {
          type: 'categories',
          categories: [
            {
              title: 'All',
              url: '/resources',
            },
            {
              title: 'Articles',
              url: '/resources/articles',
            },
            {
              title: 'Webinars',
              url: '/resources/webinars',
            },
            {
              title: 'Events',
              url: '/resources/events',
            },
            {
              title: 'eBooks',
              url: '/resources/ebooks',
            },
          ],
        },
        {
          type:'blog-posts'
        }
      ],
    },
  }],


  it: [{
    url: '/come-funziona/',
    title: 'Prodotto',
    subnav: {
      layout: '',
      items: [
        {
          title: 'Come funziona',
          url: '/it/come-funziona/',
          description: 'Fai crescere la tua attività grazie a contenuti visivi su misura e di qualità superiore, facilissimi da ordinare.',
          icon: '/subnav/hiw.svg',
        },
        {
          title: 'Funzionalità',
          url: '/it/funzionalita/',
          description:
            'Elimina tutti gli ostacoli nella produzione di contenuti, accelerando il flusso di lavoro e incrementando le vendite.',
          icon: '/subnav/features.svg',
        },
        {
          title: 'Integrazioni',
          url: '/it/integrazioni/',
          description:
            'Collega la tua forza vendite, il cloud e gli strumenti di gestione dei contenuti. Fatti consegnare i contenuti esattamente dove ti servono.',
          icon: '/subnav/integrations.svg',
        },
        {
          className: 'bg-beige',
          title: 'Prezzi',
          url: '/it/prezzi/',
          description:
            'I nostri prezzi sono equi, fissi e trasparenti. Includi tutti i tuoi ordini in un\'unica fattura da pagare mensilmente.',
          icon: '/subnav/pricing.svg',
        },
      ],
    },
  },
  {
    url: '/it/enterprise/',
    title: 'Enterprise',
  },
  {
    url: '#',
    title: 'Azienda',
    subnav: {
      layout: '',
      items: [
        {
          title: 'Chi siamo',
          url: '/it/chi-siamo/',
          description: 'Abbiamo creato la prima piattaforma per la produzione di contenuti visivi al mondo. Questa è la nostra storia.',
          icon: '/subnav/about-new.png',
        },
        {
          title: 'Posizioni aperte',
          url: '/it/carriere/',
          description: 'Amiamo ciò che facciamo e le persone con cui lavoriamo. Entra a far parte del team.',
          icon: '/subnav/careers-new.png',
        },
        {
          title: 'Contatti',
          url: '/it/contatti/',
          description: 'Contatta il nostro team di vendita o chatta con l\'assistenza clienti. Siamo qui per te.',
          icon: '/subnav/contact-new.png',
        },
        {
          type: 'block-row',
          items: [
            {
              title: 'Il nostro manifesto',
              url: '/it/manifesto/',
              description: 'Stiamo definendo standard completamente nuovi per la produzione di contenuti.',
            },
            {
              title: 'Impatto',
              url: '/it/social-impact/',
              description: 'La nostra piattaforma di produzione globale implica una responsabilità a livello mondiale.',
            },
            {
              title: 'Stampa',
              url: '/it/stampa/',
              description: 'Trova tutte le risorse di alta qualità di cui hai bisogno o parla con il nostro team di PR.',
            },
          ],
        },
      ],
    },
  },
  {
    url: '/it/resources/',
    title: 'Risorse',
    subnav: {
      layout: 'resources',
      items: [
        {
          type: 'categories',
          categories: [
            {
              title: 'Tutto',
              url: '/it/resources/',
            },
            {
              title: 'Articoli',
              url: '/it/resources/articles/',
            },
            {
              title: 'Webinars',
              url: '/it/resources/webinars/',
            },
            {
              title: 'Eventi',
              url: '/it/resources/events/',
            },
            {
              title: 'eBooks',
              url: '/it/resources/ebooks/',
            },
          ],
        },
        {
          type:'blog-posts'
        }
      ],
    },
  }],

  fr: [{
    url: '/fr/comment-cela-fonctionne',
    title: 'Produit',
    subnav: {
      layout: '',
      items: [
        {
          title: 'Comment ça marche',
          url: '/fr/comment-cela-fonctionne',
          description: 'Développez votre activité grâce à des visuels sur mesure, plus faciles que jamais à commander.',
          icon: '/subnav/hiw.svg',
        },
        {
          title: 'Caractéristiques',
          url: '/fr/fonctionnalites',
          description:
            'Supprimez tous les obstacles dans la production de contenu, accélérez votre flux de travail et augmentez vos ventes.',
          icon: '/subnav/features.svg',
        },
        {
          title: 'Intégrations',
          url: '/fr/integrations',
          description:
            'Connectez vos outils de vente, de cloud computing et de gestion de contenu. Obtenez du contenu livré exactement là où vous en avez besoin.',
          icon: '/subnav/integrations.svg',
        },
        {
          className: 'bg-beige',
          title: 'Tarification',
          url: '/fr/prix',
          description:
            'Notre tarification est juste, uniforme et transparente. Mettez toutes vos commandes sur une seule facture, payée mensuellement.',
          icon: '/subnav/pricing.svg',
        },
      ],
    },
  },
  {
    url: '/fr/enterprise',
    title: 'Entreprise',
  },
  {
    url: '#',
    title: 'Compagnie',
    subnav: {
      layout: '',
      items: [
        {
          title: 'À propos de nous',
          url: '/fr/qui-nous-sommes',
          description: 'Nous avons créé la première plateforme de production visuelle au monde. Voici notre histoire.',
          icon: '/subnav/about-new.png',
        },
        {
          title: 'Carrières',
          url: '/fr/carriere',
          description: 'Nous aimons ce que nous faisons, et nous aimons les personnes avec qui nous le faisons. Rejoignez notre équipe.',
          icon: '/subnav/careers-new.png',
        },
        {
          title: 'Contact',
          url: '/fr/contact',
          description: 'Contactez notre équipe de vente ou discutez avec le service d\'assistance. Nous sommes toujours là pour vous.',
          icon: '/subnav/contact-new.png',
        },
        {
          type: 'block-row',
          items: [
            {
              title: 'Notre Manifeste',
              url: '/fr/manifesto',
              description: 'Nous établissons des normes entièrement nouvelles pour la production de contenu.',
            },
            {
              title: 'Impact',
              url: '/fr/social-impact',
              description: 'Notre plateforme de production mondiale implique une responsabilité mondiale.',
            },
            {
              title: 'Presse',
              url: '/fr/press',
              description: 'Trouvez toutes les ressources de première qualité dont vous avez besoin ou parlez-en avec notre équipe de relations publiques.',
            },
          ],
        },
      ],
    },
  },
  {
    url: '/fr/resources',
    title: 'Ressources',
    subnav: {
      layout: 'resources',
      items: [
        {
          type: 'categories',
          categories: [
            {
              title: 'All',
              url: '/fr/resources',
            },
            {
              title: 'Articles',
              url: '/fr/resources/articles',
            },
            {
              title: 'Webinaires',
              url: '/fr/resources/webinars',
            },
            {
              title: 'Événements',
              url: '/fr/resources/events',
            },
            {
              title: 'Téléchargements',
              url: '/fr/resources/ebooks',
            },
          ],
        },
        {
          type:'blog-posts'
        }
      ],
    },
  }],


  es: [{
    url: '/es/como-funciona',
    title: 'Producto',
    subnav: {
      layout: '',
      items: [
        {
          title: 'How it works',
          url: '/es/como-funciona',
          description: 'Aumenta tu negocio con mejores imágenes personalizadas más fáciles de encargar que nunca.',
          icon: '/subnav/hiw.svg',
        },
        {
          title: 'Prestaciones',
          url: '/es/funcionalidades',
          description:
            'Elimina cualquier complicación de la producción de contenido, acelera tu flujo de trabajo y logra más ventas.',
          icon: '/subnav/features.svg',
        },
        {
          title: 'Integraciones',
          url: '/es/integraciones',
          description:
            'Conecta tus herramientas de ventas, de la nube y de gestión de contenidos. El contenido se enviará exactamente donde lo necesites.',
          icon: '/subnav/integrations.svg',
        },
        {
          className: 'bg-beige',
          title: 'Precios',
          url: '/es/precios',
          description:
            'Nuestros precios son justos, planos y transparentes. Incluye todos tus encargos en una sola factura al mes.',
          icon: '/subnav/pricing.svg',
        },
      ],
    },
  },
  {
    url: '/es/enterprise',
    title: 'Enterprise',
  },
  {
    url: '#',
    title: 'Empresa',
    subnav: {
      layout: '',
      items: [
        {
          title: 'Sobre nosotros',
          url: '/es/sobre-nosotros',
          description: 'Hemos creado la primera Plataforma de Producción Visual del mundo. Esta es nuestra historia.',
          icon: '/subnav/about-new.png',
        },
        {
          title: 'Empleos',
          url: '/es/carreras',
          description: 'Nos encanta lo que hacemos y nos encanta con quién lo hacemos. Únete al equipo.',
          icon: '/subnav/careers-new.png',
        },
        {
          title: 'Contact',
          url: '/es/contacte',
          description: 'Saluda a nuestro equipo de Ventas o chatea con el soporte técnico. Estamos encantados de atenderte.',
          icon: '/subnav/contact-new.png',
        },
        {
          type: 'block-row',
          items: [
            {
              title: 'Our Manifesto',
              url: '/es/manifesto',
              description: 'Estamos estableciendo estándares completamente nuevos para la producción de contenido.',
            },
            {
              title: 'Impacto',
              url: '/es/social-impact',
              description: 'Nuestra plataforma de producción global comporta una responsabilidad global.',
            },
            {
              title: 'Prensa',
              url: '/es/prensa',
              description: 'Encuentra todos los activos de alta calidad que necesitas o habla con nuestro equipo de Relaciones Públicas.',
            },
          ],
        },
      ],
    },
  },
  {
    url: '/es/resources',
    title: 'Recursos',
    subnav: {
      layout: 'resources',
      items: [
        {
          type: 'categories',
          categories: [
            {
              title: 'All',
              url: '/es/resources',
            },
            {
              title: 'Artículos',
              url: '/es/resources/articles',
            },
            {
              title: 'Seminarios web',
              url: '/es/resources/webinars',
            },
            {
              title: 'Eventos',
              url: '/es/resources/events',
            },
            {
              title: 'Descargas',
              url: '/es/resources/ebooks',
            },
          ],
        },
        {
          type:'blog-posts'
        }
      ],
    },
  }],


}
